import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

import SkeletonField from './SkeletonField'
import SkeletonTable from './SkeletonTable'

export type SkeletonUploadProps = {
    infoBar?: boolean
    fields?: number
    helpLines?: number
    tableRows?: number
    tableColumns?: number
}

export default function SkeletonUpload(props: Readonly<SkeletonUploadProps>) {
    const { infoBar = false, fields = 0, helpLines = 0, tableRows = 0, tableColumns = 4 } = props

    return (
        <Grid container spacing={2} size={12}>
            <Grid size={12}>
                <Paper sx={{ p: 2 }}>
                    <Stack spacing={1}>
                        <Skeleton variant="text" width={220} sx={{ fontSize: '1.5rem' }} />
                        {helpLines > 0 && <Skeleton variant="text" width="60%" />}
                    </Stack>
                </Paper>
            </Grid>

            <Grid size={12}>
                <Paper sx={{ p: 3 }}>
                    {infoBar && <Skeleton variant="rounded" height={44} sx={{ mb: 2 }} />}

                    {fields > 0 && (
                        <Grid container spacing={3} rowSpacing={3} sx={{ mb: 3 }}>
                            {Array.from({ length: fields }, (_, index) => (
                                <Grid key={index} size={{ xs: 12, md: index === 0 ? 12 : 6 }}>
                                    <SkeletonField />
                                </Grid>
                            ))}
                        </Grid>
                    )}

                    <Box
                        sx={{
                            border: '1px dashed',
                            borderColor: 'divider',
                            borderRadius: 1,
                            height: 88,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Skeleton variant="text" width={320} />
                    </Box>

                    {helpLines > 0 && (
                        <Stack spacing={1} sx={{ alignItems: 'center', mt: 3 }}>
                            {Array.from({ length: helpLines }, (_, index) => (
                                <Skeleton key={index} variant="text" width={`${50 - index * 6}%`} />
                            ))}
                        </Stack>
                    )}

                    <Stack direction="row" spacing={2} sx={{ justifyContent: 'center', py: 3 }}>
                        <Skeleton variant="rounded" width={280} height={40} />
                        <Skeleton variant="rounded" width={280} height={40} />
                    </Stack>

                    {tableRows > 0 && (
                        <Box>
                            <Skeleton
                                variant="text"
                                width={160}
                                sx={{ fontSize: '1.5rem', mb: 2 }}
                            />
                            <SkeletonTable
                                rows={tableRows}
                                columns={tableColumns}
                                showToolbar={false}
                            />
                        </Box>
                    )}
                </Paper>
            </Grid>
        </Grid>
    )
}
